import React, { ReactNode } from "react";
import { IListObj } from "../../../../types/genericTypes";
import DeviceContext from "../../../../service/indentifyDevice";
import { AObEqReq, AObEqHistReq, AObEqSIP } from "../../../../service/orderBook/obApiService";
// import eqData from "../../sample/eqData.json";
import { filterArrData } from "../../../../service/arrayFilter";
import { eqNav } from "../../obConstants";
import ObEquity from "../../instruments/secondaryMarket/obEquity";
import { Idevice } from "../../../../types/device";
import ObEquityMob from "../../instruments/secondaryMarket/obEquityMob";
import moment from "moment";
import NoDataContainer from "../../../../generic/noDataContainer";
import { SDevWiseStateComp } from "../obDeviceComp";
import Loader, { SLoader } from "../../../../generic/loader";

export interface IObEqContainerProps {
	match?: any;
}

const ObEqContainer: React.FC<IObEqContainerProps> = (props) => {
	const [hidepgNav, setHidePageNav] = React.useState<boolean>(false);
	const [instrument, setInstrument] = React.useState<ReactNode>(<></>);
	let filteredData: Array<{}> = [];
	const obLoader = (
		<div className="loaderWrap">
			<Loader size={20} color="blue" />
		</div>
	);

	// priNavOptions do not change (no need of state)
	const priNavOptions: Array<IListObj> = [
		{ value: "today", display: "Today's orders", href: eqNav.today },
		{ value: "history", display: "History", href: eqNav.history },
		{ value: "sip", display: "SIP Orders", href: eqNav.sip }
	];

	//url params controlled vars
	let activeSecNav: string = props.match.params.secNav.toLowerCase();
	let history: boolean = props.match.params.pageNav === priNavOptions[1].value ? true : false;
	let sip: boolean = props.match.params.pageNav === priNavOptions[2].value ? true : false;
	let isLoading: boolean = false;

	const setNHandle = (data: any) => {
		filteredData = data;
		handleSecNav();
	};

	const eqOrderBookRes = (res: any) => {
		if (!history && !sip) {
			res.data ? setNHandle(res.data.ord) : setNHandle([]);
		}
	};

	const eqOrderBookHistRes = (res: any) => {
		if (history) {
			isLoading = false;

			res.data ? setNHandle(res.data.hstOrdBk) : setNHandle([]);
		}
	};

	const sipOrderBook = (res: any) => {
		if (sip) {
			(res.response ? res.response.data.spreq : res.response) ? setNHandle(res.response.data.spreq) : setNHandle([]);
		}
	};

	//handle page navigation today's, history data
	const handlePageNav = (selectVal: string) => {
		isLoading = true;
		handleSecNav();
		switch (selectVal) {
			case "history":
				history = true;
				sip = false;
				isLoading = true;
				setNHandle([]);
				break;
			case "today":
				history = false;
				sip = false;
				setInstrument(obLoader);
				AObEqReq(eqOrderBookRes);
				break;
			case "sip":
				history = false;
				sip = true;
				setInstrument(obLoader);
				AObEqSIP(sipOrderBook);
				break;
			default:
				console.log("not found");
				break;
		}
	};

	React.useEffect(() => {
		handlePageNav(props.match.params.pageNav);
	}, [props.match.params.pageNav]);

	const getDates = (fromDt: Date, toDate: Date) => {
		if (history) {
			AObEqHistReq(eqOrderBookHistRes, moment(fromDt).format("MM/DD/YYYY"), moment(toDate).format("MM/DD/YYYY"));
		}
	};

	const handleDevice: Idevice = DeviceContext();
	//toggler to show and hide the page navigation in the events of any operation
	const hidePageNav = (toggle: boolean) => {
		setHidePageNav(toggle);
	};

	//handles section navigation based on page navigation
	const handleSecNav = () => {
		if (filteredData.length > 0) {
			if (!history && !sip) {
				filteredData = filterArrData(filteredData, "asTyp", "EQUITY", "=");
			} else if (history) {
				//filter out cds and derviative orders
				filteredData = filterArrData(filteredData, "exc", "NFO", "!");
				filteredData = filterArrData(filteredData, "exc", "CDS", "!");
			}
		}
		let inst: ReactNode = <></>,
			nodataNode: ReactNode = <></>;

		//show no data container
		if (filteredData.length === 0) {
			nodataNode = (
				<NoDataContainer
					txtHeading={history || sip ? "" : `You haven’t placed any Equity orders today`}
					txtSubHeading={
						!history && !sip
							? "Investing today can help you grow your wealth"
							: sip
							? "There are no Equity SIP orders placed by you" // message if there are no SIP orders
							: "There are no orders for the selected date range and asset class"
					}
					btnDet={{
						txt: history ? "Today's Orders" : "Place Order",
						href: history ? "today" : "temp",
						clickHandler: () => {},
						type: history ? "bLink" : "btn"
					}}
				/>
			);
		}
		if (history || filteredData.length !== 0) {
			inst =
				handleDevice.isDesktop || handleDevice.isTablet ? (
					<ObEquity
						data={filteredData}
						isHistory={history}
						hidePageNav={hidePageNav}
						getDates={getDates}
						isSip={sip}
						aType={activeSecNav}
						reRenderCall={handlePageNav}
					/>
				) : (
					<ObEquityMob
						data={filteredData}
						isHistory={history}
						hidePageNav={hidePageNav}
						getDates={getDates}
						isSip={sip}
						aType={activeSecNav}
					/>
				);
		}
		setInstrument(
			<>
				{inst}
				{((history && !isLoading) || !history) && nodataNode}
				{history && isLoading && SLoader(20, "blue")}
			</>
		);
	};
	return <>{SDevWiseStateComp(priNavOptions, instrument, hidepgNav)}</>;
};

export default ObEqContainer;
